import { format } from 'date-fns'
import { useGetActivityLogByKeys } from './useGetActivityLogByKeys'
import { ActivityLogV2Content } from '@/catalog-apps/components/SupportPanel/TemplatesV2/ActivityLogV2/ActivityLogV2Content'
import { useDownloadFile } from '@/catalog-apps/components/SupportPanel/TemplatesV2/useDownloadFile'

export function TemplateActivityLog({ entityGuid, templateKey }: { entityGuid: string; templateKey: string }) {
  const { data: activityLog } = useGetActivityLogByKeys({ entityGuid, templateKey })
  const { mutate: downloadFile, isPending } = useDownloadFile()

  const firstActivity = activityLog.at(0)
  const lastActivity = activityLog.at(-1)

  if (!firstActivity || !lastActivity) return <div>No activity</div>
  const {
    user,
    date,
    url,
    file_template: { id: templateId },
    entity: { id: entityId },
  } = firstActivity
  const updatedText = `Updated ${user ? `by ${user} on` : ''} ${format(new Date(date), 'PPP')}`
  // const NextAction = renderNextAction(lastActivity)
  const handleDownloadTemplate = () => {
    downloadFile({ url: url, fileName: firstActivity.file_name })
  }
  return (
    <ActivityLogV2Content
      activityLog={activityLog}
      lastActivity={lastActivity}
      url={url}
      updatedText={updatedText}
      handleDownloadTemplate={handleDownloadTemplate}
      isPending={isPending}
      entityId={entityId}
      templateId={templateId}
    />
  )
}
